<template>
  <div class="container" id="application-form">

    <div class="notice" v-if="!saved">
      <h2>注意事項</h2>
      <ul>
        <li>每次儲存報名表，都會清除之前的報名資料。以最後一次報名資訊為準。</li>
        <li>每人最多可報四個項目，其中個人項目最多三個項目。</li>
      </ul>
    </div>

    <div class="row">
      <div class="col-md-6 col-sm-12">

        <div class="items-list" v-if="!confirming && !saved">
          <h2>報名項目</h2>
          <div class="loading" v-if="loading">
            loading...
          </div>
          <div class="done" v-else>
            <ul class="list-group">
              <li class="list-group-item"
                v-for="(item, index) in displayItems"
                :key="index"
                @click="clickItem(item)"
                :class="{ disabled: shouldDisable(item) }">
                <span class="glyphicon glyphicon-ok" v-if="isSelectedItem(item)"></span>
                {{ item.label }}
              </li>
            </ul>
            <button class="btn btn-primary" @click="confirming = true">下一步</button>
          </div>
        </div>

        <div v-if="confirming && !saved">
          <h2>確認報名項目</h2>
          <div class="alert alert-info">
            <ul>
              <li v-for="(item, index) in selectedItems" :key="index">{{ item.label }}</li>
            </ul>
          </div>
          <div class="btn-group">
            <button class="btn btn-default" @click="confirming = false">返回</button>
            <button class="btn btn-primary" @click="confirm">確定</button>
          </div>
        </div>

      </div>
      <div class="col-md-6 col-sm-12">

        <div class="personal-information" v-if="!saved">
          <h2>個人資料</h2>
          <div class="alert alert-warning">
            <dl class="row">
              <dt class="col-xs-4 text-right">校部</dt>
              <dd class="col-xs-8">{{ info.school_name }}</dd>
              <dt class="col-xs-4 text-right">姓名</dt>
              <dd class="col-xs-8">{{ info.name }}</dd>
              <dt class="col-xs-4 text-right">班級</dt>
              <dd class="col-xs-8">{{ info.classroom_name }}（{{ info.number }}）</dd>
              <dt class="col-xs-4 text-right">組別</dt>
              <dd class="col-xs-8">{{ group }}組</dd>
            </dl>
          </div>
        </div>

      </div>
    </div>

    <div v-if="saved">
      <div class="alert alert-success">
        <h3>報名表已提交</h3>
        <p>你可以：</p>
        <ul>
          <li>關閉瀏覽器；或</li>
          <li>重新登入以確認報名項目；或</li>
          <li>返回登入頁面以重新登入。</li>
        </ul>
      </div>
      <button class="btn btn-primary" @click="reload">重新登入</button>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import p from 'es6-promise';
  import allItems from '../items.json';

  p.polyfill();

  export default {
    name: 'ApplicationForm',
    data() {
      return {
        allItems,
        selectedItems: [],
        confirming: false,
        saved: false,
        loading: true,
      };
    },
    props: ['info'],
    computed: {
      displayItems() {
        return allItems
          .filter(item => item.category === this.info.category)
          .filter(item => item.sex === this.info.sex);
      },
      group() {
        const sex = this.info.sex === 'm' ? '男子' : '女子';
        return `${sex}${this.info.category.toUpperCase()}`;
      },
    },
    methods: {
      confirm() {
        axios.post('https://cdsj-sports-day.herokuapp.com/apply', {
          info: this.info,
          items: this.selectedItems,
        }).then(() => {
          this.saved = true;
        });
      },
      shouldDisable(what) {
        const count = this.selectedItems.filter(item => item.relay === what.relay).length;
        let fulled = false;
        if (what.relay) {
          fulled = count >= 2;
        } else {
          fulled = count >= 3;
        }
        fulled = this.selectedItems.length >= 4 ? true : fulled;

        return fulled && !this.isSelectedItem(what);
      },
      isSelectedItem(what) {
        return this.selectedItems.indexOf(what) >= 0;
      },
      addItem(what) {
        this.selectedItems.push(what);
      },
      removeItem(what) {
        const index = this.selectedItems.indexOf(what);
        this.selectedItems.splice(index, 1);
      },
      clickItem(what) {
        if (!this.shouldDisable(what)) {
          if (this.isSelectedItem(what)) {
            this.removeItem(what);
          } else {
            this.addItem(what);
          }
        }
      },
      reload() {
        window.location.reload();
      },
      mount() {
        axios
          .get('https://cdsj-sports-day.herokuapp.com/query', {
            params: {
              sid: this.info.id,
            },
          })
          .then((res) => {
            if (res.status === 200) {
              const response = res.data.map(item => item.item);
              this.allItems.forEach((item) => {
                if (response.includes(item.label)) {
                  this.selectedItems.push(item);
                }
              });
            }
            this.loading = false;
          });
      },
    },
    mounted() {
      this.mount();
    },
  };
</script>

<style scoped>
#application-form {
  padding-bottom: 48px;
}
h2 {
  margin-top: 48px;
}
.personal-information dl {
  margin-bottom: 0;
}
.personal-information dt, .personal-information dd {
  line-height: 2.62;
}
li {
  line-height: 2.62;
}
.items-list .glyphicon {
  color: #27ae60;
}
p {
  line-height: 1.6;
  margin-bottom: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/ApplicationForm.vue